import { render, staticRenderFns } from "./WaiterFamilyListTab.vue?vue&type=template&id=3871afda&scoped=true&lang=pug"
import script from "./WaiterFamilyListTab.vue?vue&type=script&lang=ts"
export * from "./WaiterFamilyListTab.vue?vue&type=script&lang=ts"
import style0 from "./WaiterFamilyListTab.vue?vue&type=style&index=0&id=3871afda&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3871afda",
  null
  
)

export default component.exports